import { LabelType } from "@faro-lotv/ielement-types";
import {
  ClusterElement,
  ClustersRecord,
  IElementsState,
  selectIElement,
  selectRootId,
} from "@faro-lotv/project-source";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "./store";

/** The store with only the iElements slice */
export type OnlyIElementsStore = {
  iElements: IElementsState;
};

/**
 * @param state The current state of the store
 * @returns The iElements slice of the store
 */
export function selectIElementsSlice(
  state: OnlyIElementsStore,
): IElementsState {
  return state.iElements;
}

/**
 * @param state The current state of the store
 * @returns Array of all clusters in the project
 */
export const selectClusterArray: (state: RootState) => ClusterElement[] =
  createSelector(
    (state: RootState) => state.iElements.clusters,
    (clusterMap: ClustersRecord) => {
      // clusterMap can contain undefined as values, at least according to the type ClusterRecord.
      // We need to filter those out.
      const clusters: ClusterElement[] = [];
      for (const key in clusterMap) {
        const cluster = clusterMap[key];
        if (cluster !== undefined) {
          clusters.push(cluster);
        }
      }
      return clusters;
    },
  );

/**
 * @returns The id of the label marking the root element as a VideoMode copy, if any
 */
export const selectVideoModeCopyTag = createSelector(
  [selectIElementsSlice],
  computeVideoModeCopyTag,
);

function computeVideoModeCopyTag(
  iElements: IElementsState,
): string | undefined {
  const state = { iElements };
  const rootEl = selectIElement(selectRootId(state))(state);
  return rootEl?.labels?.find(
    (label) => label.labelType === LabelType.Videomode,
  )?.id;
}
